import { Injectable, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { select, Store } from "@ngrx/store";
import { filter, take } from "rxjs/operators";

import { selectorLanguage } from "@app/core/i18n/i18n.reducer";

@Injectable()
export class ConfigurableBaseEffect {
  translate = inject(TranslateService);
  readonly store = inject<Store<any>>(Store);

  constructor() {
    this.store
      .pipe(
        select(selectorLanguage),
        take(1),
        filter((lang) => lang)
      )
      .subscribe((lang) => {
        this.translate.setDefaultLang(lang.currentLanguage);
      });
  }
}
